import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useProductSelectionSection} from '../ProductInformationBox/MiniArticleDetail/useGetMinimalProductBulkSection';
import {ProductSelectionSkeleton} from './ProductSelectionSkeleton';
import {
  ProductSelectionView,
  ProductSelectionViewProps,
} from './ProductSelectionView';

export const ProductSelectionMinimal = (
  props: ProductSelectionViewProps & {productId: number} & {
    ref?: React.Ref<HTMLElement>;
  },
) => {
  const {ref} = props;
  return (
    <DataFetcher
      request={useProductSelectionSection(props.productId)}
      Error={() => null}
      Loading={ProductSelectionSkeleton}
      View={ProductSelectionView}
      viewProps={{...props, ref}}
    />
  );
};
